import makeStyles from '@mui/styles/makeStyles';

const useSolarPlantListStyles = makeStyles({
  root: {
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      boxShadow: "4px 4px 15px rgba(0, 0, 0, 0.05)",
      borderRadius: "50px",
      // width: "120px !important",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },
    "& .MuiInputBase-root": {
      color: "#000",
      // backgroundColor: "transparent",
      borderRadius: "50px",
      border: "none",
        fontSize: '12px',
    },
    datePicker: {
      color: "#000",
      backgroundColor: "white",
      border: "none",
      width: "120px !important",
      height:'48px !important',
      boxShadow: "1px 4px 15px rgba(0, 0, 0, 0.05)",
  
      "& .MuiOutlinedInput-root": {
        border: "none",
        height: "48px",
        width: "120px !important",
      },
      "& .MuiOutlinedInput-input": {
        border: "none",
        padding: "10px",
        width: "120px !important",
      },
    },
  }
});

export default useSolarPlantListStyles;
